// Users only. Shared table methods are in tableMixin.js.
export default {
    name: "Users",
    methods: {
        // Add button: empty form (every field, incl. date of birth and photo)
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.showPassword = false;
            this.currentUserRole = "";
            this.formInputs = this.getDefaultFormInputs();
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = "";
            }
            this.$clearValidationStates("#recordForm");
        },
        // After the table loads (tableMixin calls this): how many users are online
        afterFetch(response) {
            this.tableData.usersOnline = response.data.results.usersOnline || { online: 0, total: 0 };
        },
        // Users shows only the first server message (message[0]); this replaces the shared one on this page
        handleError(daOrigin, error, daClass, daPageOrModal) {
            this.button_text = "";
            this.alertType = "danger";
            if (error && error.data && error.data.message) {
                this.defaultAlert.alertMessage = error.data.message[0];
            } else {
                this.defaultAlert.alertMessage = error;
            }
            this.showAlert = true;
            this.handleAlert(daOrigin, this.defaultAlert.alertMessage, daClass, daPageOrModal);
            console.error("Error:", this.defaultAlert.alertMessage);
        },
        handleFetchRolesSuccess(response) {
            this.rolesOptions = response.data.results;
        },
    },
};